import { defineWidgetCore } from "../../widgetDefinition";
import { NoPdf } from "../../widgetContract";
import type { SpacerComponentSpec } from "../../Processing/types";

export const spacerCore = defineWidgetCore<SpacerComponentSpec>({
  process(spec) {
    return { type: "spacer", spec };
  },
  pdf: NoPdf,
});
